"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var o = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, o.get ? o : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var o = n(e),
    _r = function r() {
  return (_r = Object.assign || function (e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      for (var r in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    a = function a() {
  return o.createElement(t.Icon, {
    size: 16
  }, o.createElement("path", {
    d: "M11.5 19.5L11.5 5"
  }), o.createElement("path", {
    d: "M17 14L11.5 19.5 6 14"
  }), o.createElement("path", {
    d: "M17.5.5h5a1,1,0,0,1,1,1v21a1,1,0,0,1-1,1h-5"
  }), o.createElement("path", {
    d: "M6.5.5h-5a1,1,0,0,0-1,1v21a1,1,0,0,0,1,1h5"
  }));
},
    c = {
  left: 0,
  top: 8
},
    i = function i(e) {
  var n = e.onClick,
      r = o.useContext(t.LocalizationContext),
      i = r && r.download ? r.download.download : "Download";
  return o.createElement(t.Tooltip, {
    ariaControlsSuffix: "get-file",
    position: t.Position.BottomCenter,
    target: o.createElement(t.MinimalButton, {
      ariaLabel: i,
      onClick: n
    }, o.createElement(a, null)),
    content: function content() {
      return i;
    },
    offset: c
  });
},
    l = function l(e) {
  var t = e.children,
      n = e.fileNameGenerator,
      r = e.store,
      a = o.useState(r.get("file")),
      c = a[0],
      l = a[1],
      u = function u(e) {
    l(e);
  };

  o.useEffect(function () {
    return r.subscribe("file", u), function () {
      r.unsubscribe("file", u);
    };
  }, []);
  return (t || function (e) {
    return o.createElement(i, {
      onClick: e.onClick
    });
  })({
    onClick: function onClick() {
      var e, t, o, r;
      c && (e = c, t = n(c), o = "string" == typeof e.data ? "" : URL.createObjectURL(new Blob([e.data], {
        type: "application/pdf"
      })), (r = document.createElement("a")).style.display = "none", r.href = o || e.name, r.setAttribute("download", t), document.body.appendChild(r), r.click(), document.body.removeChild(r), o && URL.revokeObjectURL(o));
    }
  });
},
    u = function u(e) {
  var n = e.onClick,
      r = o.useContext(t.LocalizationContext),
      c = r && r.download ? r.download.download : "Download";
  return o.createElement(t.MenuItem, {
    icon: o.createElement(a, null),
    onClick: n
  }, c);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


exports.DownloadIcon = a, exports.getFilePlugin = function (e) {
  var n = o.useMemo(function () {
    return t.createStore({});
  }, []),
      a = function a(e) {
    return "object" == typeof e.data ? "document.pdf" : (t = e.name, (n = t.split("/").pop()) ? n.split("#")[0].split("?")[0] : t);
    var t, n;
  },
      c = function c(t) {
    return o.createElement(l, _r({}, t, {
      fileNameGenerator: e && e.fileNameGenerator || a,
      store: n
    }));
  };

  return {
    onViewerStateChange: function onViewerStateChange(e) {
      return n.update("file", e.file), e;
    },
    Download: c,
    DownloadButton: function DownloadButton() {
      return o.createElement(c, null, function (e) {
        return o.createElement(i, _r({}, e));
      });
    },
    DownloadMenuItem: function DownloadMenuItem(e) {
      return o.createElement(c, null, function (t) {
        return o.createElement(u, {
          onClick: function onClick() {
            t.onClick(), e.onClick();
          }
        });
      });
    }
  };
};